// extracted by mini-css-extract-plugin
module.exports = {"c1nib967":"c1nib967","h18qk5wd":"h18qk5wd"};